export enum WeightTypeEnum {
    KG = "10",
    LIBRA = "20",
  }
  